module.exports = __webpack_public_path__ + "static/media/coins.cfcaa8f4.jpg";